import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { generateAlertsHTML } from '../utils/alertsGenerator';

const CompetitionAlerts = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const renderAlertsFrame = () => {
    if (loading) {
      return (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-accent"></div>
        </div>
      );
    }

    // Create the iframe with the alerts HTML content
    return (
      <iframe
        srcDoc={generateAlertsHTML()}
        title="Competition Alerts"
        className="w-full h-[80vh] border-0 rounded-xl"
        sandbox="allow-same-origin"
      />
    );
  };

  return (
    <div className="min-h-screen bg-secondary text-white relative">
      {/* Background Effect */}
      <div className="absolute inset-0 overflow-hidden z-0">
        <div className="absolute -top-1/2 -left-1/4 w-3/4 h-3/4 bg-orange-500/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-1/2 -right-1/4 w-3/4 h-3/4 bg-red-500/5 rounded-full blur-3xl"></div>
        <div className="absolute top-1/4 left-1/3 w-1/3 h-1/3 bg-yellow-500/5 rounded-full blur-3xl"></div>
      </div>

      <header className="bg-primary/80 backdrop-blur-md px-6 py-4 border-b border-border-color sticky top-0 z-10">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <h1 className="text-xl font-bold text-white">Competition Movement Alerts</h1>
          <button
            onClick={() => navigate('/chat')}
            className="text-sm px-4 py-2 rounded-md bg-accent hover:bg-accent/90 transition-colors shadow-lg shadow-accent/20"
          >
            Back to Chat
          </button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-8 relative z-1">
        <div className="bg-primary/90 rounded-2xl shadow-2xl overflow-hidden backdrop-blur-xl border border-white/5 relative">
          <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-accent/5 opacity-50"></div>
          <div className="p-8 relative">
            <div className="mb-6 pb-6 border-b border-border-color flex justify-between items-center">
              <div>
                <h2 className="text-3xl font-extrabold bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
                  Recent Competitor Movements
                </h2>
                <p className="text-gray-400">Live monitoring of key competitive metrics</p>
              </div>
              <div className="bg-accent/20 p-3 rounded-full shadow-lg shadow-accent/10">
                <span className="text-accent text-2xl">🔔</span>
              </div>
            </div>

            {renderAlertsFrame()}

            <div className="mt-8 pt-4 border-t border-border-color">
              <p className="text-gray-400 text-sm">
                These alerts are generated by monitoring competitor activities across various channels including social media,
                app stores, websites, and pricing data. Alert priorities are determined by AI analysis of potential market impact.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CompetitionAlerts;
